document.addEventListener('DOMContentLoaded', () => {
    // Function to fetch search results
function fetchSearchResults(query) {
    const endpoint = '/wp-json/wp/v2/help_center_items?search=' + query;

    // Fetch the search results
    fetch(endpoint)
        .then(response => response.json())
        .then(results => displaySearchResults(results))
        .catch(error => console.error(error));
}

// Function to display search results
function displaySearchResults(results) {
    const searchResults = document.getElementById('search-results');
    searchResults.innerHTML = '';

    if (results.length > 0) {
        results.forEach(result => {
            const listItem = document.createElement('li');
            listItem.classList.add('list-group-item');
            listItem.innerHTML = '<a href="' + result.link + '">' + result.title.rendered + '</a>';
            searchResults.appendChild(listItem);
        });
    } else {
        const listItem = document.createElement('li');
        listItem.classList.add('list-group-item', 'text-muted');
        listItem.innerText = 'No results found.';
        searchResults.appendChild(listItem);
    }
}

// Event listener for search input
const searchInput = document.getElementById('search-input');
  searchInput.addEventListener('input', (event) => {
    const query = event.target.value.trim();
    if (query.length > 0) {
      fetchSearchResults(query);
    } else {
      document.getElementById('search-results').innerHTML = '';
    }
  });
});